import React, {useState, useEffect} from 'react';
import {
  Container,
  Typography,
  Box,
  Button,
} from '@mui/material';
import {useTranslation} from 'react-i18next';
import CompanyEntry from './CompanyEntry';
import Header from '../common/Header';
import StrapiService from "../strapi/StrapiService";
import axios from 'axios';
import {BASIC_URL} from "../enum";
import {useNavigate} from "react-router-dom";

const CompanyPage = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const [localedIndustryObjects, setLocaledIndustryObjects] = useState([]);
  const [userCompany, setUserCompany] = useState('');
  const [companyType, setCompanyType] = useState('');
  const [companySize, setCompanySize] = useState('');

  const fetchData = async () => {
    const user = await StrapiService.getCurrentUser()
      .then(user => {
        setUserCompany(user.Unternehmen || '');
        setCompanyType(user.Rechtsform || '');
        setCompanySize(user.Unternehmensgroesse || '');
        return user;
      })
      .catch(e => {
        console.error(e);
        localStorage.removeItem('jwt');
        localStorage.removeItem('user');
        navigate('/login');
      });
    const token = localStorage.getItem('jwt');
    const company = encodeURIComponent(user.Unternehmen);
    const response = await axios.get(
      `${BASIC_URL}/api/industrie-objects?filters[Company][$eq]=${company}&locale=*&status=draft&populate=*`,
      {
        headers: {Authorization: `Bearer ${token}`},
      }
    );

    const grouped = [];
    const map = new Map();

    for (const item of response.data.data) {
      const {documentId, locale} = item;

      if (!map.has(documentId)) {
        map.set(documentId, {documentId});
        grouped.push(map.get(documentId));
      }
      map.get(documentId)[locale] = item;
    }
    setLocaledIndustryObjects(grouped);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleAddObject = () => {
    if (localedIndustryObjects.length < 20) {
      const newId = `temp-${Date.now()}`;
      setLocaledIndustryObjects((prev) => [...prev, {documentId: newId, saved: false, de: {}, en: {}}]);
    }
  };

  const handleUpdateObject = () => {
    fetchData()
  };

  const handleDeleteObject = () => {
    fetchData()
  };

  return (
    <>
      <Container maxWidth="md" sx={{mt: 4, mb: 6, pb: 3}}>
        <Typography variant="h4" align="center" gutterBottom>
          {t('company_form.title')}
        </Typography>

        {localedIndustryObjects.length === 0 ? (
          <Typography align="center" sx={{my: 4}}>
            {t('company_form.no_objects')}
          </Typography>
        ) : (
          localedIndustryObjects.map((object) => (
            <CompanyEntry
              key={object.documentId}
              localedIndustrieObject={object}
              onUpdate={handleUpdateObject}
              onDelete={handleDeleteObject}
              userCompany={userCompany}
              companyType={companyType}
              companySize={companySize}
            />
          ))
        )}

        {localedIndustryObjects.length < 20 && (
          <Box display="flex" justifyContent="center" mt={2}>
            <Button
              variant="outlined"
              onClick={handleAddObject}
              sx={{
                borderColor: '#0063a6',
                color: '#0063a6',
                borderWidth: 2,
                fontWeight: 600,
                '&:hover': {
                  borderColor: '#94c11c',
                  color: '#94c11c',
                  borderWidth: 2,
                  backgroundColor: 'rgba(148, 193, 28, 0.06)',
                },
              }}
            >
              + {t('company_form.add_object')}
            </Button>
          </Box>
        )}
      </Container>
    </>
  );
};

export default CompanyPage;
